import { Controller } from "@hotwired/stimulus"

// Searchable customer picker for invoice form.
export default class extends Controller {
  static targets = ["input", "results", "customerId", "customerType"]
  static values = { customers: Array }

  connect() {
    this._onClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener("click", this._onClickOutside)
    this.syncInitialSelection()
  }

  disconnect() {
    document.removeEventListener("click", this._onClickOutside)
  }

  search(event) {
    if (event?.type === "input") {
      this.customerIdTarget.value = ""
      if (this.hasCustomerTypeTarget) this.customerTypeTarget.value = ""
      this.element.dispatchEvent(new CustomEvent("invoice-form:recalculate", { bubbles: true }))
    }

    const query = this.inputTarget.value.trim().toLowerCase()
    const customers = this.customersValue || []

    if (!query) {
      this.renderResults(customers.slice(0, 8))
      return
    }

    const filtered = customers
      .filter((customer) => customer.name.toLowerCase().includes(query))
      .slice(0, 12)

    this.renderResults(filtered)
  }

  select(event) {
    const id = Number(event.currentTarget.dataset.id)
    const customer = (this.customersValue || []).find((c) => Number(c.id) === id)
    if (!customer) return

    this.inputTarget.value = customer.name
    this.customerIdTarget.value = customer.id
    if (this.hasCustomerTypeTarget) this.customerTypeTarget.value = customer.customer_type || ""

    this.hideResults()
    this.element.dispatchEvent(new CustomEvent("invoice-form:recalculate", { bubbles: true }))
  }

  selectCreated(event) {
    const customer = event.detail
    if (!customer || !customer.id) return

    const exists = (this.customersValue || []).some((c) => Number(c.id) === Number(customer.id))
    if (!exists) {
      this.customersValue = [customer, ...(this.customersValue || [])]
    }

    this.inputTarget.value = customer.name
    this.customerIdTarget.value = customer.id
    if (this.hasCustomerTypeTarget) this.customerTypeTarget.value = customer.customer_type || ""
    this.hideResults()
    this.element.dispatchEvent(new CustomEvent("invoice-form:recalculate", { bubbles: true }))
  }

  syncInitialSelection() {
    const selectedId = Number(this.customerIdTarget.value)
    if (!selectedId) return

    const customer = (this.customersValue || []).find((c) => Number(c.id) === selectedId)
    if (!customer) return

    this.inputTarget.value = customer.name
    if (this.hasCustomerTypeTarget) this.customerTypeTarget.value = customer.customer_type || ""
  }

  renderResults(customers) {
    if (!customers.length) {
      this.resultsTarget.innerHTML = '<p class="px-3 py-2 text-sm text-slate-400 italic">No customers found</p>'
      this.resultsTarget.classList.remove("hidden")
      return
    }

    this.resultsTarget.innerHTML = customers
      .map(
        (customer) => `
          <button type="button"
                  class="w-full text-left px-3 py-2.5 hover:bg-primary/5 active:bg-primary/10 transition-colors"
                  data-action="click->customer-search#select"
                  data-id="${customer.id}">
            <span class="text-sm font-medium text-slate-800 dark:text-slate-200">${this.escapeHtml(customer.name)}</span>
          </button>
        `
      )
      .join("")
    this.resultsTarget.classList.remove("hidden")
  }

  hideResults() {
    this.resultsTarget.classList.add("hidden")
    this.resultsTarget.innerHTML = ""
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hideResults()
    }
  }

  escapeHtml(str) {
    return str.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
  }
}
